import React, { forwardRef } from 'react';
import ManageTestUI from '../../../ui/ManageTest/ManageTestUI';

const ManageTest = forwardRef((props, ref) => {
  return <ManageTestUI {...props} role="instructor" ref={ref} />;
});

export default ManageTest;
